import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { io } from 'socket.io-client';

@Injectable({
  providedIn: 'root',
})
export class MockSocketService {
  public message$: BehaviorSubject<string> = new BehaviorSubject('');
  private baseUrl = '';
  public socket: any;
  constructor() {
    this.baseUrl = '';
  }

  setupSocketConnection() {
    const token = localStorage.getItem('token');
  }

  joinRoom(room: string) {
    return '';
  }

  getOutboundPayment(): Observable<string> {
    return of('');
    //return this.message$.asObservable();
  }
}
